import {
  INVALID_OTP,
  INVALID_OTP_LENGTH,
  OTP_REQUIRED,
} from '../constants/validations';
import * as Yup from 'yup';

export const OTP_VALIDATION_SCHEMA = Yup.object({
  otpCode: Yup.string()
    .required(OTP_REQUIRED)
    .matches(/^\d+$/, INVALID_OTP)
    .length(4, INVALID_OTP_LENGTH),
});

export const EMAIL_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
});
